import Phaser from "phaser";
import { DIRS, SCALE, TICK_TIME, TURNINGS } from "../../../utils/constants";
import UI from "../../UI";
import Boulder from "../Boulder";
import Explosion from "../Explosion";
import GameObject from "../GameObject";
import Ground from "../Ground";

class BranchChunk extends GameObject {
  constructor(boss, branchId, color) {
    super({
      id: "root",
      isRigid: true,
      isBreakable: false,
      isFlat: true,
      isPickable: false,
      isCrushable: false,
      level: boss.level,
    });
    this.strength = 18;
    this.color = color;
    this.alien = null;
    this.branchId = branchId;
    this.boss = boss;
    this.isHorizontal = true;
    this.elbowOrientation = false;
    this.isHead = true;
    this.lastAnimationKey = ""
  }
  setPosition(coords) {
    super.setPosition(coords);
    // this.alien = this.level.scene.add
    //   .rectangle(
    //     UI.tileToScreen(coords.x),
    //     UI.tileToScreen(coords.y),
    //     UI.tileToScreen(1),
    //     UI.tileToScreen(1),
    //     this.color
    //   )
    //   .setOrigin(0, 0)
    //   .setAlpha(0.5)
    this.orientation = this.boss.getChunkOrientation(this, this.branchId);
    const IS_HORIZONTAL = [DIRS.RIGHT, DIRS.LEFT].includes(this.orientation);
    this.isHorizontal = IS_HORIZONTAL;

    // console.log();
    this.alien = this.level.scene.add
      .sprite(0, 0)
      .setOrigin(0.5, 0.5)
      .setScale(SCALE())
      .setPosition(
        UI.tileToScreen(coords.x) + UI.tileToScreen(0.5),
        UI.tileToScreen(coords.y) + UI.tileToScreen(0.5)
      );
    // this.alien.play(keyFrameName)
    this.changeOrientation(this.orientation);

    const toDestroy = this.level.getObjectAt(coords.x, coords.y);
    if (toDestroy && toDestroy.isClass(Ground)) {
      toDestroy.overrunBy(); // ignoring param works like a quake or explosion
      this.level.onDestroyElement(toDestroy);
    }
    this.level.setObjectAt(coords.x, coords.y, this);
  }
  changeOrientation(orientation) {
    if (orientation === DIRS.RIGHT) {
      this.alien.setRotation(0);
      this.alien.setFlipX(false);
    }
    if (orientation === DIRS.LEFT) {
      this.alien.setRotation(0);
      this.alien.setRotation(-Math.PI);
      // this.alien.setFlipX(true);
    }
    if (orientation === DIRS.UP) {
      this.alien.setRotation(-Math.PI / 2);
      this.alien.setFlipX(false);
    }
    if (orientation === DIRS.DOWN) {
      this.alien.setRotation((-3 * Math.PI) / 2);
      // this.alien.setFlipX(true);
    }
  }
  setElbowOrientation(orientation) {
    // CW
    if (orientation === DIRS.UP + DIRS.RIGHT) {
      this.alien.setRotation(0);
      this.alien.setFlipX(false);
    }
    if (orientation === DIRS.RIGHT + DIRS.DOWN) {
      this.alien.setRotation(Math.PI / 2);
      this.alien.setFlipX(false);
    }
    if (orientation === DIRS.DOWN + DIRS.LEFT) {
      this.alien.setRotation(Math.PI);
      this.alien.setFlipX(false);
    }
    if (orientation === DIRS.LEFT + DIRS.UP) {
      this.alien.setRotation((3 * Math.PI) / 2);
      this.alien.setFlipX(false);
    }

    // CCW
    if (orientation === DIRS.UP + DIRS.LEFT) {
      this.alien.setRotation(0);
      this.alien.setFlipX(true);
    }
    if (orientation === DIRS.LEFT + DIRS.DOWN) {
      this.alien.setRotation(-Math.PI / 2);
      this.alien.setFlipX(true);
    }
    if (orientation === DIRS.DOWN + DIRS.RIGHT) {
      this.alien.setRotation(-Math.PI);
      this.alien.setFlipX(true);
    }
    if (orientation === DIRS.RIGHT + DIRS.UP) {
      this.alien.setRotation((-3 * Math.PI) / 2);
      this.alien.setFlipX(true);
    }
  }
  getTurning(orientation) {
    if (
      [
        DIRS.UP + DIRS.RIGHT,
        DIRS.RIGHT + DIRS.DOWN,
        DIRS.DOWN + DIRS.LEFT,
        DIRS.LEFT + DIRS.UP,
      ].includes(orientation)
    ) {
      return TURNINGS.CW;
    } else {
      return TURNINGS.CCW;
    }
  }
  animHeadEntrance(fromPos) {}
  animHeadExit(toPos) {}
  animGrow() {
    return new Promise(res => {

      this.elbowOrientation = this.boss.isElbow(this, this.branchId);
      let evenOddKey;
      // horizontal mid chunk
      if (this.isHorizontal) {
        if (this.position.x % 2 === this.position.y % 2) {
          evenOddKey = "Even";
        } else {
          evenOddKey = "Odd";
        }
      } else {
        // vertical mid chunk
        if (this.position.x % 2 !== this.position.y % 2) {
          evenOddKey = "Odd";
        } else {
          evenOddKey = "Even";
        }
      }
  
      if (this.boss.chunkIsHead(this, this.branchId)) {
        // HEAD
        if (this.position.x % 2 === this.position.y % 2) {
          evenOddKey = "Odd";
        } else {
          evenOddKey = "Even";
        }
        const keyFrameName = `chunkHead${evenOddKey}_grow`;
        this.alien.play(keyFrameName);
        this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, res)
        this.lastAnimationKey = keyFrameName;
      } else if (this.elbowOrientation === false) {
        // MID CHUNK
        if (this.lastAnimationKey.includes("Head")) {
          const keyFrameName = `chunkHorizontal${evenOddKey}_grow`;
          this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            const newKeyFrameName = keyFrameName.replace("_grow", "_idle");
            this.alien.play(newKeyFrameName);
            this.lastAnimationKey = newKeyFrameName;
            res()
          });
          this.alien.play(keyFrameName);
        } else {
          res()
        }
      } else {
        // ELBOW
        if (this.lastAnimationKey.includes("Head")) {
          let nextKeyFrameName;
          if (this.position.x % 2 !== this.position.y % 2) {
            if (this.getTurning(this.elbowOrientation) === TURNINGS.CW) {
              nextKeyFrameName = "chunkCurveEven_grow";
              this.alien.play(nextKeyFrameName);
              this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                this.setElbowOrientation(this.elbowOrientation);
                this.alien.play('chunkCurveOdd_idle');
                res()
              })
              this.lastAnimationKey = nextKeyFrameName;
            } else {
              nextKeyFrameName = "chunkCurveOdd_grow";
              this.alien.setFlipY(true);
              this.alien.play(nextKeyFrameName);
              this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                this.alien.setFlipY(false);
                this.setElbowOrientation(this.elbowOrientation);
                this.alien.play('chunkCurveEven_idle');
                res()
              })
              this.lastAnimationKey = nextKeyFrameName;
            }
          } else {
            if (this.getTurning(this.elbowOrientation) === TURNINGS.CW) {
              nextKeyFrameName = "chunkCurveOdd_grow";
              this.alien.play(nextKeyFrameName);
              this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                this.setElbowOrientation(this.elbowOrientation);
                this.alien.play('chunkCurveEven_idle');
                res()
              })
              this.lastAnimationKey = nextKeyFrameName;
            } else {
              nextKeyFrameName = "chunkCurveEven_grow";
              this.alien.setFlipY(true);
              this.alien.play(nextKeyFrameName);
              this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                this.alien.setFlipY(false);
                this.setElbowOrientation(this.elbowOrientation);
                this.alien.play('chunkCurveOdd_idle');
                res()
              })
              this.lastAnimationKey = nextKeyFrameName;
            }
          }
        } else {
          res()
        }
      }
    })
  }
  animDetachment() {
    this.alien?.destroy()
  }
  animReduction() {
    return new Promise(res => {
      let evenOddKey
      // horizontal mid chunk
      if (this.isHorizontal) {
        if (this.position.x % 2 === this.position.y % 2) {
          evenOddKey = "Even";
        } else {
          evenOddKey = "Odd";
        }
      } else {
        // vertical mid chunk
        if (this.position.x % 2 !== this.position.y % 2) {
          evenOddKey = "Odd";
        } else {
          evenOddKey = "Even";
        }
      }
      
      let nextKeyFrameName
      if (this.boss.chunkIsHead(this, this.branchId)) {
        // anim reduction for head chunk
        if (this.position.x % 2 === this.position.y % 2) {
          evenOddKey = "Odd";
        } else {
          evenOddKey = "Even";
        }
        nextKeyFrameName = `chunkHead${evenOddKey}_shrink`
        this.alien.play(nextKeyFrameName)
        this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, res)
        this.lastAnimationKey = nextKeyFrameName;
        
      } else if (this.boss.chunkIsNeck(this, this.branchId)) {
        // neck can be straight or elbow
        if(this.elbowOrientation) {
          // anim reduction for elbow chunks
          if (this.position.x % 2 !== this.position.y % 2) {
            if (this.getTurning(this.elbowOrientation) === TURNINGS.CW) {
              
              this.changeOrientation(this.orientation)
              nextKeyFrameName = "chunkCurveEven_shrink";
              this.alien.play(nextKeyFrameName);
              this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                nextKeyFrameName = 'chunkHeadEven_idle'
                this.alien.play(nextKeyFrameName);
                this.lastAnimationKey = nextKeyFrameName;
                res()
              })
            } else {
              this.changeOrientation(this.orientation)
              nextKeyFrameName = "chunkCurveOdd_shrink";
              this.alien.setFlipY(true);
              this.alien.setFlipX(false);
              this.alien.play(nextKeyFrameName);
              this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                // this.alien.setFlipX(true);
                this.alien.setFlipY(false);
                nextKeyFrameName = 'chunkHeadEven_idle'
                this.alien.play(nextKeyFrameName);
                this.lastAnimationKey = nextKeyFrameName;
                res()
              })
            }
          } else {
            if (this.getTurning(this.elbowOrientation) === TURNINGS.CW) {
              this.changeOrientation(this.orientation)
              nextKeyFrameName = "chunkCurveOdd_shrink";
              this.alien.play(nextKeyFrameName);
              this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                nextKeyFrameName = 'chunkHeadOdd_idle'
                this.alien.play(nextKeyFrameName);
                this.lastAnimationKey = nextKeyFrameName;
                res()
              })
            } else {
              nextKeyFrameName = "chunkCurveEven_shrink";
              this.changeOrientation(this.orientation)
              this.alien.setFlipY(true);
              this.alien.setFlipX(false);
              this.alien.play(nextKeyFrameName);
              this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                this.alien.setFlipY(false);
                nextKeyFrameName = 'chunkHeadOdd_idle'
                this.alien.play(nextKeyFrameName);
                this.lastAnimationKey = nextKeyFrameName;
                res()
              })
            }
          }
        } else {
          // anim reduction for middle chunks
          const keyFrameName = `chunkHorizontal${evenOddKey}_shrink`;
          this.alien.play(keyFrameName);
          this.alien.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            let nextKeyFrameName = keyFrameName.replace('_shrink', '_idle').replace('Horizontal', 'Head');
            nextKeyFrameName = nextKeyFrameName.includes('Odd') ? nextKeyFrameName.replace('Odd', 'Even') : nextKeyFrameName.replace('Even', 'Odd')
            this.alien.play(nextKeyFrameName)
            this.lastAnimationKey = nextKeyFrameName;
            res()
          });
        }
        
      } else {
        res()
      }
    })
  }
  animDestroy() {
    this.alien.setAlpha(0.3);
    setTimeout(() => this.alien.destroy(), TICK_TIME);
  }
  hitBy(el) {
    if (el.isClass(Boulder)) {
      console.log("hit by a rock");
      this.boss.takeBranchDamage(this.branchId, 1);
    }

    if (el.isClass(Explosion)) {
      console.log("burnt");
      this.boss.takeBranchDamage(this.branchId, 5);
    }
  }
}
BranchChunk.className = "BranchChunk";
export default BranchChunk;
